import { BefehlFormAuftrag } from '../Generic'
import { useTranslation } from 'react-i18next'

export interface Auftrag7_10FormProps {
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag7_10Form({
  'data-testid': testId
}: Readonly<Auftrag7_10FormProps>) {
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="7.10"
      fieldName="auftrag_7_10.enabled"
      readOnly={true}
      testId={testId}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.7_10.label')}</span>
    </BefehlFormAuftrag>
  )
}
